<script lang="ts">
  import { Button, type Language } from '@bond/components'
  import AppRating from './AppRating.svelte'
  import AppDownload from './AppDownload.svelte'
  import { page } from '$app/stores'
  import { STRINGS } from '$lib/constants/strings'
  import { utils } from '$lib/utils'

  $: lang = $page.params.lang as Language
  $: localeRoute = utils.getRoute(lang)

  export let title = true
  export let center = false
  export let description = true
  export let readMore = true
</script>

<div class="information" class:center>
  {#if title}
    <h2>{STRINGS[lang].BRUCE_INFORMATION_TITLE}</h2>
  {/if}
  {#if description}
    <p>
      {STRINGS[lang].BRUCE_INFORMATION_DESCRIPTION}
    </p>
  {/if}
  {#if readMore}
    <Button href={localeRoute('/get-started')} rounded variant="outlined">
      {STRINGS[lang].BRUCE_INFORMATION_READ_MORE_BUTTON}
    </Button>
  {/if}
  <AppRating />
  <div class="downloads">
    <AppDownload badge="app-store" />
    <AppDownload badge="google-play" />
  </div>
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .information {
    display: flex;
    flex-direction: column;
    gap: 1.25em;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      align-items: center;
    }

    &.center {
      align-items: center;
    }

    h2 {
      margin: 0;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        margin: 0 16px;
        text-align: center;
      }
    }

    p {
      margin: 0;
      max-width: 400px;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        margin: 0 16px;
        text-align: center;
      }
    }

    .downloads {
      display: flex;
      gap: 1em;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        flex-direction: column;
      }
    }
  }
</style>
